import React, { Dispatch, useMemo } from 'react';
import { FilterItemGroup } from '../FilterItemGroup';
import { FilterItem } from '../FilterItem';
import { PostScheduleViewContext } from '../../../modules/Publish/PostSchedule/PostSchedule.controller';
import { PostScheduleFilterAction, PostScheduleFilterType } from '../../../models/post';
import { PostQueueCountResult, QueueFilterPostStatus, QueueFilterPostTiming } from '../../../models/graphql';
import classes from './PostStatusFilterGroup.module.scss';
import { PostScheduleHelpers } from '../../../modules/Publish/PostSchedule/postScheduleHelpers';
import { FilterCountColor } from '../FilterItem/FilterItem.view';

export type PostStatusFilterGroupViewProps = {
  loading: boolean;
  dispatchFilters: Dispatch<PostScheduleFilterAction>;
  activeFilterId?: string;
  context: PostScheduleViewContext;
  queueCounts: PostQueueCountResult;
  filters: PostScheduleFilterType;
};

export const PostStatusFilterGroupView = (props: PostStatusFilterGroupViewProps): JSX.Element => {
  const { queueCounts } = props;
  const setSelectedFilter = (id: string) => {
    props.dispatchFilters({ type: 'status', payload: { data: id, fetchPosts: true } });
  };

  const counts = useMemo(() => PostScheduleHelpers.getQueueCounts(queueCounts, 'status'), [queueCounts]);

  return (
    <FilterItemGroup isFiltered={!!props.activeFilterId} title={'Post Status'}>
      {(props.context === PostScheduleViewContext.WEEK || props.context === PostScheduleViewContext.LIST) && (
        <>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.SCHEDULED}
            count={counts.scheduled}
            loading={props.loading}
            setSelectedHandler={() => setSelectedFilter(QueueFilterPostStatus.SCHEDULED)}>
            <div className={classes.Label}>Upcoming</div>
          </FilterItem>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.PAST}
            count={counts.past}
            loading={props.loading}
            setSelectedHandler={() => setSelectedFilter(QueueFilterPostStatus.PAST)}>
            <div className={classes.Label}>Published</div>
          </FilterItem>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.FAILED}
            count={counts.failed}
            loading={props.loading}
            setSelectedHandler={() => setSelectedFilter(QueueFilterPostStatus.FAILED)}
            countColor={FilterCountColor.RED}>
            <div className={classes.Label}>Failed</div>
          </FilterItem>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.PAUSED}
            count={counts.paused}
            loading={props.loading}
            setSelectedHandler={() => setSelectedFilter(QueueFilterPostStatus.PAUSED)}>
            <div className={classes.Label}>Paused</div>
          </FilterItem>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.DRAFT}
            count={counts.draft}
            loading={props.loading}
            setSelectedHandler={() => setSelectedFilter(QueueFilterPostStatus.DRAFT)}>
            <div className={classes.Label}>Draft</div>
          </FilterItem>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.UNQUEUED}
            count={counts.unqueued}
            loading={props.loading}
            setSelectedHandler={() => {
              if (
                props.filters.timing === QueueFilterPostTiming.RECURRING ||
                props.filters.timing === QueueFilterPostTiming.SET_DATES
              ) {
                props.dispatchFilters({ type: 'timing', payload: { data: '', fetchPosts: true } });
              }

              setSelectedFilter(QueueFilterPostStatus.UNQUEUED);
            }}>
            <div className={classes.Label}>Unqueued</div>
          </FilterItem>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.DELETED}
            count={counts.deleted}
            loading={props.loading}
            setSelectedHandler={() => setSelectedFilter(QueueFilterPostStatus.DELETED)}>
            <div className={classes.Label}>Trash</div>
          </FilterItem>
        </>
      )}
      {props.context === PostScheduleViewContext.LIBRARY && (
        <>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.SCHEDULED}
            count={counts.scheduled}
            loading={props.loading}
            setSelectedHandler={() => setSelectedFilter(QueueFilterPostStatus.SCHEDULED)}>
            <div className={classes.Label}>Active</div>
          </FilterItem>
          <FilterItem
            selected={props.activeFilterId === QueueFilterPostStatus.PAST}
            count={counts.past}
            loading={props.loading}
            setSelectedHandler={() => setSelectedFilter(QueueFilterPostStatus.PAST)}>
            <div className={classes.Label}>Expired</div>
          </FilterItem>
        </>
      )}
    </FilterItemGroup>
  );
};
